export const queryKeys = {
  getGovernanceActions: "getGovernanceActions",
  getGovernanceActionMetadata: "getGovernanceActionMetadata",
  getGovernanceAction: "getGovernanceAction",
  getProposal: "getProposal",
};
